<template>
  <mobile-multiselect
    v-on="$listeners"
    v-bind="$attrs"
  >
    <template #default="slotProps">
      <div class="mobile-multiselect-size__inner">
        <size
          class="scrollable"
          v-for="option in slotProps.options"
          :key="option.id"
          :is-selected="slotProps.isSelected(option)"
          :title="option.label"
          size="large"
          @click.native="slotProps.toggle(option)"
          :is-out-of-stock="option.count === 0"
        />
      </div>
    </template>
  </mobile-multiselect>
</template>

<script>
import MobileMultiselect from '@/components/mobile-multiselect/mobile-multiselect.vue';
import Size from '@kit/size/size.vue';

export default {
  components: {
    Size,
    MobileMultiselect,
  },
}
</script>

<style lang="scss">
  .mobile-multiselect-size__inner {
    display: flex;
    flex-wrap: wrap;
    margin: 20px 4px 12px 12px;

    .size {
      margin-right: 8px;
      margin-bottom: 8px;
      flex-grow: .37;
    }
  }
</style>